


import _ from 'lodash';
import { CREATE_USER_EVENT } from '../state/mutations/UserEvent';
import { OneSignal } from 'react-native-onesignal';
import { UPDATE } from '../state/mutations/User';
import { client } from '../config/apollo/client';
import { isWeb } from '../config/designSystem/Layout';
import { logAmplitude, setProperty } from '../utils/analytics/analytics';
import { showMessage } from 'react-native-flash-message';
import { useCallback } from 'react';
import { useStores } from './useStores';

export const useChangeLanguage = () => {

  const rootStore = useStores();
  const labels = rootStore?.language?.translate?.MOBILE?.SETTINGS;

  const changeLanguage = useCallback(async (languageValue: string): Promise<void> => {
    // Anonymous / not-yet-authenticated users (e.g. the reckoning introduction
    // page) have no token to persist `preferredLanguage`. Calling updateUser would
    // fail and surface a "could not change the language" banner, so just apply the
    // language locally for them.
    if (!rootStore?.user?.user?._id || rootStore?.user?.anonymous) {
      await rootStore?.language.setLanguage(languageValue, true);
      logAmplitude('Language Changed', { success: true });
      return;
    }
    try {
      const inputt = {
        _id: rootStore?.user?.user?._id,
        preferredLanguage: languageValue,
        email: rootStore?.user?.user?.email,
      };

      const { data } = await client.mutate({
        mutation: UPDATE,
        fetchPolicy:'no-cache',
        variables: {
          input: inputt,
        },
      });
      client.mutate({
        mutation: CREATE_USER_EVENT,
        fetchPolicy:'no-cache',
        variables: {
          input: {
            type:'LanguageChanged',
            params: languageValue
          }
        }
      });
      const userData = _.cloneDeep(rootStore?.user?.user);
      userData.language = data.updateUser.preferredLanguage;
      rootStore?.user.set(userData);
      if (!isWeb) {
        OneSignal.User.setLanguage(userData.language);
        await setProperty({ languageUserDefined: languageValue });
      }
      logAmplitude('Language Changed', { success: true });
      await rootStore?.language.setLanguage(languageValue, true);
    } catch (error) {
      showMessage({
        message: labels.LANGUAGE_ERROR ? labels.LANGUAGE_ERROR : 'Merci de réessayer',
        type: 'danger',
        duration: 5000,
      });
      logAmplitude('Language Changed', { success: false });
    }
  }, [labels.LANGUAGE_ERROR, rootStore?.language, rootStore?.user]);


  return changeLanguage;
};